import React, { useEffect, useState } from "react";
import { gettagmappingdata, sendTagmapping } from "../../api/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const Tagmapping = ({ renderpage }) => {
  const { fileId, category } = useParams();
  const [apiData, setApiData] = useState();
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState();
  const [stage, setStage] = useState();

  useEffect(() => {
    fetchdata(fileId);
  }, [fileId]);

  const fetchdata = async (currentFileId) => {
    try {
      let data = await gettagmappingdata(currentFileId, category);
      if (data.data) {
        setOptions(data.data.change);
        setApiData(data.data.tags);
        setStage({
          previous: data.data.previous_process,
          next: data.data.next_process,
        });
      } else {
        // alert(data.error.message);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  console.log(apiData);

  const handleChange = (e, i) => {
    const value = e.target.value;
    setSelectedValue((prev) => ({
      ...prev,
      [i]: value,
    }));
    setApiData((prev) =>
      prev.map((item, index) =>
        index === i ? { ...item, new_tag: value } : item
      )
    );
  };

  const senddata = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    try {
      if (apiData) {
        event.currentTarget.disabled = true;
        document.body.style.cursor = "wait";
        let response = await sendTagmapping(fileId, apiData);
        if (response.data) {
          document.body.style.cursor = "default";
          handleNext(fileId, stage.next);
        } else {
          // alert(response.error.message);
          toast.error(response.error.message);
          button.disabled = false; // Disable the button
          document.body.style.cursor = "default";
        }
      }
    } catch (e) {
      button.disabled = false;
      document.body.style.cursor = "default";
      toast.error(e);
      // console.log(e);
    }
  };

  const handleNext = (fileId, nextpage) => {
    renderpage(fileId, nextpage);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="p-8 flex flex-col gap-8 h-[100%] min-h-[70vh]">
        <div className="flex w-full justify-between text-left items-center">
          <h1 className="text-24 font-semibold">Tag Mapping</h1>
          <button
            onClick={() => {
              toast.info("Feature yet to be implemented");
            }}
            className="flex gap-2 px-3 py-3 border-[1.5px] border-highlighttext rounded-[12px]"
          >
            <img
              src={process.env.PUBLIC_URL + "/images/gotoeditor.svg"}
              alt="editor_logo"
            ></img>
            <p className="text-highlighttext text-14 font-semibold">
              Go to Editor
            </p>
          </button>
        </div>
        <div className="overflow-auto max-h-[600px] rounded-[16px] border-[1px] border-commonborder shadow-commonshadow">
          <table className="w-full ">
            <thead className="sticky top-0 z-10 bg-tableheadingbg px-4 py-6 text-left text-white text-16 font-semibold">
              <tr className="">
                <th className="px-4 py-5">Present Class Name</th>
                <th className="px-4 py-5" style={{ width: "45%" }}>
                  Heading Text
                </th>
                <th className="px-4 py-5">To Be Replaced as</th>
              </tr>
            </thead>
            <tbody className="w-full text-left bg-white">
              {apiData?.map((items, i) => (
                <tr
                  key={i}
                  className="border-b-[1px] border-commonborder last:border-none"
                >
                  <td className="px-4 py-5" style={{ width: "20%" }}>
                    <p className="px-4 py-3 rounded-[8px] bg-commonfill">
                      {items.tag}
                    </p>
                  </td>
                  <td className="px-4 py-5">
                    <p
                      className="px-4 py-3 rounded-[8px] bg-commonfill"
                      title={items.text}
                    >
                      {typeof items.text === "string" && items.text.length > 30
                        ? items.text.slice(0, 30) + "..."
                        : items.text}
                    </p>
                  </td>
                  <td className="px-4 py-5 relative">
                    <select
                      className="rounded-[8px] bg-commonfill px-4 py-3 w-full appearance-none"
                      style={{ accentColor: "#FF6A00" }}
                      onChange={(event) => handleChange(event, i)}
                      value={selectedValue ? selectedValue[i] : items.new_tag}
                    >
                      {options?.map((items, i) => (
                        <option key={i} value={Object.values(items)}>
                          {Object.values(items)}
                        </option>
                      ))}
                    </select>
                    <svg
                      class="absolute top-1/2 right-8 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button
          onClick={(event) => {
            senddata(event);
          }}
          className="w-full mt-20 flex justify-end"
        >
          <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
            NEXT
          </p>
        </button>
      </div>
    </div>
  );
};

export default Tagmapping;
